import { HttpError } from "@refinedev/core";

/**
 * Ошибки ТВ показываем текстом бэкенда: CMS отвечает 400 со строкой
 * («Адрес уже занят…»), общий обработчик её теряет.
 */
export const tvErrorMessage = (error: unknown): string => {
  const e = error as HttpError & { errorBody?: unknown };
  const body = e?.errorBody ?? e?.message;
  if (typeof body === "string" && body.trim()) return body;
  if (body && typeof body === "object") {
    const b = body as { message?: string; error?: string };
    if (b.message) return b.message;
    if (b.error) return b.error;
  }
  if (e?.statusCode === 401) return "Пользователь не авторизован";
  return "Что-то пошло не так, повторите попытку";
};

export const tvErrorNotification = (description = "Не сохранено") => ({
  errorNotification: (error?: unknown) => ({
    type: "error" as const,
    message: tvErrorMessage(error),
    description,
  }),
});

export const tvSuccessNotification = (
  message: string,
  callback?: () => void
) => ({
  successNotification: () => {
    callback?.();
    return { type: "success" as const, message };
  },
});
